export default {
  'UploadedFileField.UploadSubtitleButton': (payload, outlet) => {
    outlet({ action: { type: 'upload_new', payload } })
  },
  'UploadedFileField.UploadedSubtitlesWrapper.SubWrapper.DisplaySubtitleDefaultButtonWrapper.UploadSubtitles': (payload, outlet) => {
    //  "delete" and "set_default" actions are handled in the UploadedFileField component
    outlet(payload)
  },
  'UploadedFileField.UploadedSubtitlesWrapper.AddMoreSubtitleButton': (payload, outlet) => {
    outlet({ action: { type: 'add_more', payload } })
  },
}
